export const PLAYER_BLUE = 0xff085fff;
export const PLAYER_PINK = 0xfffe80e0;
export const PLAYER_DARK = 0xff161616;
/** Fixed text metrics keep the condensed labels centred at both 720p and 1080p. */
export const playerText = (text, fontSize, h = fontSize * 1.289) => ({
    text,
    fontFace: "Insatiable Display",
    fontStyle: "700",
    fontSize,
    precision: 1,
    h,
    lineHeight: h,
    offsetY: (h + fontSize * 0.74) / 2,
    textColor: 0xffffffff,
    wordWrap: false,
});
//# sourceMappingURL=styles.js.map